import React, {Component} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import ClassInfo from 'template/InfoDisplays/ClassInfo'
import getClassInfoFields from './ClassInfoFields'
import DefaultTab from './DefaultTab'
import classnames from 'classnames';
import AddLesson from 'template/Docks/AddLesson'
import {fetchClassLesson} from './ducks'
import Loading from 'components/UI/Loading';
import Transition from 'components/UI/Transition';
import isEqual from 'lodash/isEqual';
import CreateClassModal from 'template/Modals/CreateClass'
import CreateClassOneModal from 'template/Modals/CreateClassOne'
import __R, {userCan} from 'containers/__R';
import ClassDescriptionModal from 'template/Modals/ClassDescription'

import {
  Button,
	PanelWrapper,
	Tab,
	Tabs,
	TabList,
	TabPanel,
} from 'components/UI'

import './ClassDetail.scss'

const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
  classDetail: state.classLessonDetail
})

const locale = {
  id: 'ClassDetail',
  code: 'CN',
  text: {
    'Class': '班级',
  }
}
class ClassDetail extends Component{
  constructor(props){
    super(props)

    this.state = {
      classDetail: props.classDetail,
      pageState: 'current',
      pagination: {
        activePage: 1,
        itemsCountPerPage: 25,
        totalItemsCount: 0
      }
    }

    if (props.location && props.location.state) {
      this.state.addLessonWhenOpen = props.location.state.openCreateLessonDock;
    }
    this.onTabChange = this.onTabChange.bind(this);
    this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
  }

  componentWillReceiveProps({ classDetail }) {
    if (classDetail.detail && !isEqual(classDetail.detail, this.props.classDetail.detail)) {
      this.setState(prevState => {
        return {
          classDetail,
          pagination: {...prevState.pagination, totalItemsCount: classDetail.detail.lessonCount }
        }
      },
      ()=>{
        if (this.state.addLessonWhenOpen == true) {
          this.setState({
            addLessonWhenOpen: false,
          }, ()=>{
            this.addLesson(classDetail);
          });
        }
      })
    }
  }

  componentDidMount(){
    const { dispatch } = this.props;
    const { pagination } = this.state;
    const classId = this.props.params.classId;

    dispatch(fetchClassLesson(classId, {
      amount_per_page: pagination.itemsCountPerPage,
      current_page_number: 1,
      after_today: 1
    }))
  }

  onTabChange(state){
    const {dispatch} = this.props;
    const {pagination} = this.state;
    const classId = this.props.params.classId;
    this.setState(prevState => {
      return {
        pageState: state,
        pagination: {...prevState.pagination, activePage: 1, totalItemsCount: 0}
      }
    })
    dispatch(fetchClassLesson(classId, {
      amount_per_page: pagination.itemsCountPerPage,
      current_page_number: 1,
      after_today: state === 'current'? 1 : 0
    }))

  }
  onPageChange(pageNum){
    const {dispatch} = this.props;
    const {pagination, pageState} = this.state;
    const classId = this.props.params.classId;
    this.setState(prevState=>{
      return { pagination: {...prevState.pagination, activePage: pageNum}}
    },()=>{
      dispatch(fetchClassLesson(classId, {
        amount_per_page: pagination.itemsCountPerPage,
        current_page_number: pageNum,
        after_today: pageState === 'current'? 1 : 0
      }))
    })
  }

  onItemsCountPerPageChange(count){
    const {dispatch} = this.props;
    const classId = this.props.params.classId;
    const {pagination, pageState} = this.state;
    this.setState(prevState =>({
      pagination: {...prevState.pagination, itemsCountPerPage: count}
    }))
    dispatch(fetchClassLesson(classId, {
      amount_per_page: count,
      current_page_number: pagination.activePage,
      after_today: pageState === 'current'? 1 : 0
    }))
  }
  // needed for automatically open the modal when '排课' is clicked from the class list
  addLesson(classDetail) {
    const { pagination } = this.state;
    const {dispatch} = this.props
    const {detail, fetching} = classDetail || this.props.classDetail
    AddLesson({chooseClass: false, classDetail: detail})
      .then(()=>{
        dispatch(fetchClassLesson(detail.classID, {
          amount_per_page: pagination.itemsCountPerPage,
          current_page_number: pagination.activePage,
          after_today: 1
        }))
      });
  }

  renderExitNavigation(cType, cState){
    let returningPath = ''
    if(this.props.location.state != undefined){
      returningPath = this.props.location.state.returningPath
    }

    if(cType == 0 && cState == 1){
      return returningPath || '/class'
    } else if (cType == 0 && cState == 0){
      return returningPath || '/class'
    } else if (cType == 1 && cState == 1){
      return returningPath || '/one_one'
    } else if (cType == 1 && cState == 0){
      return returningPath || '/one_one'
    }
  }

  render(){
    const {pagination, pageState} = this.state;
    const { detail } = this.state.classDetail
    const { fetching } = this.props.classDetail
    const {cType, cState} = detail
    const shouldShowStudentTab = cType === 0

    if(cType == 1){
      this.fields = getClassInfoFields.call(this);
    } else {
      this.fields = getClassInfoFields.call(this);
      delete this.fields.studentList
    }

    return(
      <PanelWrapper>
        { fetching && <Loading onPanel={true} /> }
        <Transition>
          <div className={classnames('classDetail', { fetching })}>
          <div className='container-fluid class-detail-esc'>
            <div className='bread-crumbs'>
              <Link to={this.renderExitNavigation(cType, cState)}>{cType == 0 ? __('Class', 'editclass') : __('Private Class', 'editone')}</Link>
              <span> / </span>
              <span>{detail.className}</span>
              <Link className='pull-right' to={this.renderExitNavigation(cType, cState)}>
                <i className='fa icon-cancel'></i>
              </Link>
            </div>
          </div>
          <div className='container-fluid class-detail-header'>
            <span className='class-detail-name'>{detail.className}</span>
            <__R can='edit_class' by='disable'>
              <button className='pull-right btn btn-default'
                onClick={() => {
                  if(cType == 0){
                    CreateClassModal({mode: 'update', id: detail.classID, pageState, pagination })
                  } else if (cType == 1){
                    CreateClassOneModal({mode: 'update', id: detail.classID, pageState, pagination})
                  }
                }}
                disabled={!userCan(cType == 0 ? 'edit_class' :'edit_private_class') || cState == 0}
              >
                {cType == 0 ? __('Edit Class', 'editclass') : __('Edit Private Class', 'editone')}
              </button>
            </__R>

            {/* temporary testing for modal */}
            {process.env.APP_ENV === 'development' && <button className='pull-right btn' onClick={() => {ClassDescriptionModal({id: detail.classID})}}>{__('Class Description', 'class')}</button>}
          </div>
          <ClassInfo data={detail} fields={this.fields} />
          <Tabs>
            <TabList>
              <Tab>{__('Upcoming Lesson', 'classdetail')}</Tab>
              <Tab>{__('Past Lesson', 'classdetail')}</Tab>
              {shouldShowStudentTab && <Tab disabled={!userCan('read_class_student')} >{__('Students', 'class')}</Tab>}
              {shouldShowStudentTab && <Tab disabled={!userCan('read_class_student')} >{__('Past Students', 'class')}</Tab>}
              <Tab disabled={!userCan(cType == 0 ? 'read_class_teacher': 'read_private_class_teacher')} >{__('Teacher', 'changeschool')}</Tab>
            </TabList>

            <TabPanel>
              <DefaultTab title={"currentLesson"} {...this.props} onTabChange={this.onTabChange} pagination={pagination} onPageChange={this.onPageChange} onItemsCountPerPageChange={this.onItemsCountPerPageChange}/>
            </TabPanel>
            <TabPanel>
              <DefaultTab title={"pastLesson"} {...this.props} onTabChange={this.onTabChange} pagination={pagination} onPageChange={this.onPageChange} onItemsCountPerPageChange={this.onItemsCountPerPageChange}/>
            </TabPanel>
            { shouldShowStudentTab && <TabPanel>
              <DefaultTab title={"student"} {...this.props} />
            </TabPanel>}
            { shouldShowStudentTab && <TabPanel>
              <DefaultTab title={"pastStudent"} {...this.props} />
            </TabPanel>}
            <TabPanel>
              <DefaultTab title={"teacher"} {...this.props} />
            </TabPanel>
          </Tabs>
        </div>
        </Transition>
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps)(ClassDetail)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/index.js